var moment = require("moment");
import { GENDER_TYPE } from "./app";
$(document).ready(function() {
    //    $('body').on('click','#'+staffFormTabsSettings.buttons.backButton,function(){
    //         var tabForm = require('./tabForm');
    //         tabForm.goBacK(staffFormTabsSettings);
    //    });
});
var staffFormTabsSettings = {
    tabsCount: 4,
    leftTabMainwrappers: "guide-staff-tabs",
    mainWrappersClassName: "formTabWrappers",
    formIdName: "staffForm",
    feedBoxIdName: "add-staff-form-feed",
    buttons: {
        backButton: "addStaffPrevTabBtn",
        addEditButton: "stf-proceed",
    },
    fields: {
        basicDetails: {
            leftLink: "stf-basic",
            with: [1],
            fields: {
                stf_name: {
                    multi: false,
                    handType: "class",
                    hand: "stf-name",
                    with: [1],
                },
                stf_email: {
                    multi: false,
                    handType: "class",
                    hand: "stf-email",
                    with: [1],
                },
                stf_mobile: {
                    multi: false,
                    handType: "class",
                    hand: "stf-mobile",
                    with: [1],
                },
                stf_gender: {
                    multi: false,
                    handType: "class",
                    hand: "stf-gender",
                    with: [1],
                },
                stf_age: {
                    multi: false,
                    handType: "class",
                    hand: "stf-age",
                    with: [1],
                },
                stf_language: {
                    multi: false,
                    handType: "class",
                    hand: "stf-language",
                    with: [1],
                },
            },
        },
        residentialDetails: {
            leftLink: "stf-rsdt",
            with: [1],
            fields: {
                presentStreetAddress: {
                    multi: false,
                    handType: "class",
                    hand: "stf-presentStreetAddress",
                    with: [1],
                },
                timingDay: {
                    multi: false,
                    handType: "class",
                    hand: "stf-presentPincode",
                    with: [1],
                },
                presentPincode: {
                    multi: false,
                    handType: "class",
                    hand: "stf-presentState",
                    with: [1],
                },
                presentCity: {
                    multi: false,
                    handType: "class",
                    hand: "stf-presentCity",
                    with: [1],
                },
                permanentStreetAddress: {
                    multi: false,
                    handType: "class",
                    hand: "stf-permanentStreetAddress",
                    with: [1],
                },
                permanentPincode: {
                    multi: false,
                    handType: "class",
                    hand: "stf-permanentPincode",
                    with: [1],
                },
                permanentState: {
                    multi: false,
                    handType: "class",
                    hand: "stf-permanentState",
                    with: [1],
                },
                permanentCity: {
                    multi: false,
                    handType: "class",
                    hand: "stf-permanentCity",
                    with: [1],
                },
            },
        },
        officialInformation: {
            leftLink: "stf-official",
            with: [1],
            fields: {
                designation: {
                    multi: false,
                    handType: "class",
                    hand: "stf-designation",
                    with: [1],
                },
                specialisation: {
                    multi: false,
                    handType: "class",
                    hand: "stf-specialisation",
                    with: [1],
                },
                reportingManager: {
                    multi: false,
                    handType: "class",
                    hand: "stf-reportingManager",
                    with: [1],
                },
            },
        },
        credentialDetails: {
            leftLink: "stf-credential",
            with: [1],
            fields: {
                password: {
                    multi: true,
                    handType: "class",
                    hand: "stf-password",
                    with: [1],
                },
                confirmPassword: {
                    multi: true,
                    handType: "class",
                    hand: "stf-confirmPassword",
                    with: [1],
                },
            },
        },
    },
};
var topActionBtnAppStaff = new Vue({
    el: "#topActionBtnStaff",
    methods: {
        openAddStaff: function() {
            staffManage.staffData = {};
            staffManage.staffData = {
                name: "",
                mobile: "",
                email: "",
                permanentStreetAddress: "",
                permanentPincode: "",
                permanentState: "",
                permanentCity: "",
                document: "",
                language: [],
                documentAbsolutePath: [],
                designation: [],
                specialisation: [],
            };
            staffManage.formHeader = "Add Staff";
            staffManage.createNew = true;
            staffManage.openStaffForm();
            var tabForm = require("./tabForm");
            var argsReset = {
                tabUlIdName: "guide-staff-tabs",
                formIdName: "staffForm",
                mainWrappersClassName: "formTabWrappers",
            };
            tabForm.setToFirstTab(argsReset);
        },
    },
});

window.staffManage = new Vue({
    el: "#addStaff",
    data: {
        formHeader: "Add Staff",
        createNew: true,
        staffData: {
            name: "",
            email: "",
            mobile: "",
            dob: "",
            gender: "",
            permanentStreetAddress: "",
            permanentPincode: "",
            permanentState: "",
            permanentCity: "",
            document: "",
            language: [],
            documentAbsolutePath: [],
            designation: [],
            specialisation: [],
        },
        readOnlyEmail: false,
        readOnlyMobile: false,
        designationList: [],
        specialisationList: [],
        userList: [],
        errorMessage: "",
        attachaments: {},
        formData: new FormData(),
        file_data: [],
        languageList: {},
        staffDocumentList: [],
        removedDocumentList: [],
        firstCityFetch: true,
        selectedPresentLocality: [],
        selectedPresentCity: [],
        selectedPresentState: [],
        selectedPermanentLocality: [],
        selectedPermanentCity: [],
        selectedPermanentState: [],
        isDisabled: true,
        isLocalityDisabled: false,
        localityCityStateList: [],
        localityList: [],
        stateList: [],
        cityList: [],
        genderList: GENDER_TYPE,
        selectedGender: [],
        selectedLanguage: [],
        langauageArrayList: [],
        permanentLocalityList: [],
        presentLocalityList: [],
        selectedDesignation: [],
        selectedSpecialisation: [],
        selectedReportingManager: [],
        verificationError: "",
    },
    mounted: function() {
        $(".multiselect__input").each(function() {
            var input = $(this);
            input
                .closest(".multiselect")
                .attr("id", input.attr("id") + "-multiselect");
        });
        $(".multiselect__single").each(function() {
            var input = $(this);
            var multiselectDiv = input.closest(".multiselect");
            multiselectDiv.attr(
                "id",
                multiselectDiv.data("id") + "-multiselect"
            );
        });
        $("#presentPincode").change(function() {
            var presentPincode = $(this).val();
            if (presentPincode == "") {
                staffManage.selectedPresentLocality = [];
                staffManage.selectedPresentCity = [];
                staffManage.selectedPresentState = [];
                staffManage.localityCityStateList = [];
                staffManage.cityList = [];
                staffManage.presentLocalityList = [];
            } else {
                staffManage.getRelatedLocalityCityState(
                    presentPincode,
                    "present"
                );
            }
        });
        $("#permanentPincode").change(function() {
            var permanentPincode = $(this).val();
            if (permanentPincode == "") {
                staffManage.selectedPermanentLocality = [];
                staffManage.selectedPermanentCity = [];
                staffManage.selectedPermanentState = [];
                staffManage.localityCityStateList = [];
                staffManage.cityList = [];
                staffManage.permanentLocalityList = [];
            } else {
                staffManage.getRelatedLocalityCityState(
                    permanentPincode,
                    "permanent"
                );
            }
        });
        $(document).on("hidden.bs.modal", "#addStaff", function() {
            setTimeout(function() {
                $("#staffForm label.error").hide();
                $("#staffForm span.errorMessage").html("");
            }, 1);
        });
    },
    methods: {
        openStaffForm: function() {
            this.getDesignationList();
            this.getSpecialisationList();
            this.getUserList();
            this.getAllLanguageList();
            $("#addStaff").modal("show");
            $(".editStaffDetailsDatePick").datetimepicker({
                format: "d/m/Y",
                timepicker: false,
                scrollInput: false,
                maxDate: 0,
                onChangeDateTime: function(dp, $input) {
                    var inputModel = $input.data("model");
                    staffManage.staffData[inputModel] = $input.val();
                },
            });
            //            setTimeout(function () {
            //                $("#addStaff label.error").hide();
            //                $("#addStaff #userGender").trigger('change');
            //                $("#addStaff .select-two").each(function(){
            //                    var val = $(this).val();
            //                    $(this).removeClass('error');
            //                    $(this).select2('destroy').select2({
            //                        theme: "bootstrap",
            //                        minimumResultsForSearch: Infinity,
            //                        width: '100%'
            //                    });
            //                });
            //            }, 1);
            if (this.formHeader == "Add Staff") {
                this.resetForm();
                //                this.resetAddressForm();
                this.isLocalityDisabled = false;
                this.readOnlyEmail = false;
                this.readOnlyMobile = false;
            }
            this.verificationError = "";
        },
        getRelatedLocalityCityState: function(pincode, address) {
            this.$http
                .get("/localitycitystate/list", {
                    params: { pincode: pincode },
                })
                .then((response) => {
                    if (
                        !response.data.hasError &&
                        typeof response.data.result.result == "object" &&
                        response.data.result.result != ""
                    ) {
                        $("#presentPincode-error")
                            .text(" ")
                            .hide();
                        this.localityCityStateList =
                            response.data.result.result;
                        this.localityList = response.data.result.result;
                        if (address == "present") {
                            this.presentLocalityList =
                                response.data.result.result;
                            this.selectedPresentLocality = [];
                            if (this.formHeader == "Add Staff") {
                                $.each(
                                    this.presentLocalityList,
                                    function(i, item) {
                                        if (
                                            typeof item.stateId !==
                                                "undefined" &&
                                            typeof item.cityId !== "undefined"
                                        ) {
                                            this.selectedPresentState = item;
                                            this.selectedPresentCity = item;
                                        }
                                    }.bind(this)
                                );
                            } else if (this.formHeader == "Update Staff") {
                                $.each(
                                    this.presentLocalityList,
                                    function(i, item) {
                                        if (
                                            typeof this.staffData
                                                .presentLocalityId !==
                                                "undefined" &&
                                            item.localityId ==
                                                this.staffData.presentLocalityId
                                        ) {
                                            this.selectedPresentLocality = item;
                                        }
                                        if (
                                            typeof item.stateId !==
                                                "undefined" &&
                                            typeof item.cityId !== "undefined"
                                        ) {
                                            this.selectedPresentState = item;
                                            this.selectedPresentCity = item;
                                        }
                                    }.bind(this)
                                );
                            }
                        }
                        if (address == "permanent") {
                            this.permanentLocalityList =
                                response.data.result.result;
                            this.selectedPermanentLocality = [];
                            if (this.formHeader == "Add Staff") {
                                $.each(
                                    this.permanentLocalityList,
                                    function(i, item) {
                                        if (
                                            typeof item.stateId !==
                                                "undefined" &&
                                            typeof item.cityId !== "undefined"
                                        ) {
                                            this.selectedPermanentState = item;
                                            this.selectedPermanentCity = item;
                                        }
                                    }.bind(this)
                                );
                            } else if (this.formHeader == "Update Staff") {
                                $.each(
                                    this.permanentLocalityList,
                                    function(i, item) {
                                        if (
                                            typeof this.staffData
                                                .permanentLocalityId !==
                                                "undefined" &&
                                            item.localityId ==
                                                this.staffData
                                                    .permanentLocalityId
                                        ) {
                                            this.selectedPermanentLocality = item;
                                        }
                                        if (
                                            typeof item.stateId !==
                                                "undefined" &&
                                            typeof item.cityId !== "undefined"
                                        ) {
                                            this.selectedPermanentState = item;
                                            this.selectedPermanentCity = item;
                                        }
                                    }.bind(this)
                                );
                            }
                        }
                    } else {
                        $("#presentPincode-error")
                            .text("please enter a valid pincode")
                            .show();
                        if (address == "present") {
                            this.selectedPresentLocality = [];
                            this.selectedPresentCity = [];
                            this.selectedPresentState = [];
                            this.localityCityStateList = [];
                            this.localityList = [];
                            this.presentLocalityList = [];
                        }
                        if (address == "permanent") {
                            this.selectedPermanentLocality = [];
                            this.selectedPermanentCity = [];
                            this.selectedPermanentState = [];
                            this.localityCityStateList = [];
                            this.localityList = [];
                            this.permanentLocalityList = [];
                        }
                        return false;
                    }
                });
        },
        resetAddressForm: function() {
            this.selectedPresentLocality = [];
            this.selectedPresentCity = [];
            this.selectedPresentState = [];
            this.selectedPermanentLocality = [];
            this.selectedPermanentCity = [];
            this.selectedPermanentState = [];
            this.localityCityStateList = [];
            this.localityList = [];
            this.presentLocalityList = [];
            this.permanentLocalityList = [];
        },
        resetForm: function() {
            this.selectedGender = [];
            this.selectedLanguage = [];
            this.selectedDesignation = [];
            this.selectedSpecialisation = [];
            this.selectedReportingManager = [];
            this.designationList = [];
            this.specialisationList = [];
            this.userList = [];
            this.langauageArrayList = [];
            $("#staffForm")
                .find(".uploadImg")
                .remove();
        },
        stateSelect: function(value, id) {
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        citySelect: function(value, id) {
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        localitySelect: function(value, id) {
            if (id == "stfPresentLocality") {
                this.staffData.presentLocalityId = value.localityId;
            } else if (id == "stfPermanentLocality") {
                this.staffData.permanentLocalityId = value.localityId;
            }
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        genderSelect: function(value, id) {
            this.staffData.gender = value.id;
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        languageSelect: function(value, id) {
            //this.staffData.language = value.language;
            var selectedLanguageArr = [];
            for (var i = 0; i < value.length; i++) {
                selectedLanguageArr[i] = value[i]["name"];
            }
            this.staffData.language = selectedLanguageArr;
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        designationSelect: function(value, id) {
            this.staffData.designation = [];
            for (var i = 0; i < value.length; i++) {
                this.staffData.designation[i] = value[i]["name"];
            }
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        specialisationSelect: function(value, id) {
            this.staffData.specialisation = [];
            for (var i = 0; i < value.length; i++) {
                this.staffData.specialisation[i] = value[i]["code"];
            }
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        reportingManagerSelect: function(value, id) {
            this.staffData.reportingManager = value.reportingManagerCode;
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        getDesignationList: function() {
            this.$http.get("/staff/role/list").then((response) => {
                this.designationList = response.data.result;
                if (
                    this.formHeader == "Update Staff" &&
                    staffManage.staffData.designation !== undefined &&
                    staffManage.staffData.designation.length > 0
                ) {
                    staffManage.selectedDesignation = $.map(
                        staffManage.designationList,
                        function(value, index) {
                            if (
                                $.inArray(
                                    value.name,
                                    staffManage.staffData.designation
                                ) != -1
                            ) {
                                return value;
                            }
                        }
                    );
                }
                return;
            });
        },
        getSpecialisationList: function() {
            this.$http.get("/staff/specialisation/list").then((response) => {
                this.specialisationList = response.data.result;
                if (
                    this.formHeader == "Update Staff" &&
                    staffManage.staffData.specialisation !== undefined &&
                    staffManage.staffData.specialisation.length > 0
                ) {
                    staffManage.selectedSpecialisation = $.map(
                        staffManage.specialisationList,
                        function(value, index) {
                            if (
                                $.inArray(
                                    value.code,
                                    staffManage.staffData.specialisation
                                ) != -1
                            ) {
                                return value;
                            }
                        }
                    );
                }
                return;
            });
        },
        getUserList: function() {
            if (
                staffManage.staffData.id === "" ||
                typeof staffManage.staffData.id === "undefined"
            ) {
                var ignoreReportingManagerId = "";
            } else {
                var ignoreReportingManagerId = staffManage.staffData.id;
            }
            var removeEmail = this.staffData.email;
            this.$http.get("/staff/reportingmanager/list").then((response) => {
                this.usersList = response.data.result;
                var userList = this.usersList;
                $.each(userList, function(key, value) {
                    if (value.reportingManagerEmail === removeEmail) {
                        userList.splice(key, 1);
                        return false;
                    }
                });
                this.userList = userList;
                if (
                    this.formHeader == "Update Staff" &&
                    staffManage.staffData.reportingManager !== undefined &&
                    staffManage.staffData.reportingManager
                ) {
                    //alert(staffManage.staffData.reportingManager);
                    staffManage.selectedReportingManager = $.map(
                        staffManage.userList,
                        function(value, index) {
                            if (
                                value.reportingManagerCode ==
                                staffManage.staffData.reportingManager
                            ) {
                                return value;
                            }
                        }
                    );
                    staffManage.selectedReportingManager =
                        staffManage.selectedReportingManager.length == 0
                            ? []
                            : staffManage.selectedReportingManager[0];
                }
                return;
            });
        },
        getAllLanguageList: function() {
            this.$http.get("/language").then((response) => {
                this.languageList = response.data.result;
                this.getLanguageListArr(this.languageList);
            });
        },
        getLanguageListArr: function(data) {
            if (staffManage.langauageArrayList.length == 0) {
                $.each(data, function(i, item) {
                    staffManage.langauageArrayList.push({ id: i, name: item });
                });
            }
            if (this.formHeader == "Update Staff") {
                staffManage.selectedLanguage = [];
                if (this.staffData.language !== 0) {
                    staffManage.selectedLanguage = $.map(
                        staffManage.langauageArrayList,
                        function(item, index) {
                            if (
                                $.inArray(
                                    item.name,
                                    staffManage.staffData.language
                                ) != -1
                            ) {
                                return item;
                            }
                        }
                    );
                }
            }
        },
        removeFile: function(event, targetId) {
            staffManage.removedDocumentList.push(
                $("#" + targetId)
                    .parents(".uploadImg")
                    .find(".imageThumb")
                    .attr("src")
            );
            $("#" + targetId)
                .parents(".uploadImg")
                .remove();
        },
        uploadFile: function() {
            var formData = new FormData();
            var file_data = $('input[type="file"]')[0].files;
            var fileSize = 0;
            if (file_data.length) {
                for (var i = 0; i < file_data.length; i++) {
                    var f = $('input[type="file"]')[0].files[i];
                    fileSize =
                        file_data[i].size / 1024 < fileSize
                            ? fileSize
                            : file_data[i].size / 1024;
                    var fileReader = new FileReader();
                    if (fileSize < 600 && fileSize > 0) {
                        fileReader.onload = function(e) {
                            var file = e.target;
                            $(
                                '<div class="uploadImg">' +
                                    '<img class="imageThumb" src="' +
                                    e.target.result +
                                    '" title="' +
                                    file.name +
                                    '"/>' +
                                    '<span class="removeImg">Remove</div>' +
                                    "</span>"
                            ).insertAfter("#idProof");
                            $(".removeImg").click(function() {
                                $(this)
                                    .parent(".uploadImg")
                                    .remove();
                            });
                        };
                    }
                    fileReader.readAsDataURL(f);
                    file_data[i]["id"] = i;
                    formData.append("attachments[]", file_data[i]);
                    //fileSize = file_data[i].size / 1024 < fileSize ? fileSize : file_data[i].size / 1024;
                }
                if (fileSize < 600 && fileSize > 0) {
                    this.$http.post("/uploadfile", formData).then(
                        (response) => {
                            if (!response.body.hasError) {
                                var file_count = file_data.length;
                                var i, j;
                                var filepath = [];
                                var imageArray = [];
                                for (
                                    i = file_count, j = 0;
                                    j < response.body.message.length;
                                    i++, j++
                                ) {
                                    var image = response.body.message[j];
                                    imageArray.push(image);
                                    var filename = image.originalname.substring(
                                        0,
                                        10
                                    );
                                    var filepath = image.path;
                                }
                                if (filename !== undefined) {
                                    this.staffData.document = filepath;
                                    this.staffData.documentAbsolutePath = imageArray;
                                }
                            }
                            return false;
                        },
                        (response) => {
                            toastr["error"](
                                "Upload failed, try again!",
                                "FAILED!"
                            );
                        }
                    );
                } else {
                    toastr.error(
                        "One or more file size is more than 600KB, Please upload file less than 600KB.",
                        "Error Notification"
                    );
                }
            } else {
                toastr.error("Please Choose a File", "Error Notification");
            }
        },
        createStaff: function() {
            var staffCreateLoader = Ladda.create(
                document.querySelector(".staffBtnCreateLoader")
            );
            $("#credentialEmail").text($("#email").val());
            this.staffData.dob = $("#dob").val();

            var currTab = $("#guide-staff-tabs li.active a").data("target");
            var isValid = validate.formIsValid("staffForm");
            var customValidateElements = $("#addStaff div.multiselect").map(
                function(i, element) {
                    if (
                        $(element).data("optional") === undefined ||
                        $(element).data("optional") == false
                    ) {
                        return $(element)
                            .find("input")
                            .attr("id");
                    }
                }
            );
            var otherCustomValidElements = $("#addStaff div.multiselect").map(
                function(i, element) {
                    var elemId = $(element)
                        .attr("id")
                        .replace("-multiselect", "");
                    if (
                        $(element).data("optional") === undefined ||
                        $(element).data("optional") == false
                    ) {
                        if (customValidateElements.length > 0) {
                            if (
                                $.inArray(elemId, customValidateElements) == -1
                            ) {
                                return elemId;
                            }
                        } else {
                            return elemId;
                        }
                    }
                }
            );
            var customValidate = validate.customValidateMultiSelect(
                customValidateElements
            );
            var customValidate =
                validate.customValidateMultiSelect(customValidateElements) &&
                validate.customValidateMultiSelect(otherCustomValidElements);

            if (!(isValid && customValidate && this.verificationError == "")) {
                return false;
            }
            /* var tabForm = require('./tabForm');
             var autoForward = tabForm.autoForward(staffFormTabsSettings,1);
             
             if(autoForward.status)
             {
             var activeTabId = $("div#addStaff").find(".tab-content > .active").attr('id');
             if (activeTabId === "tab1staff") {
             $('#addStaffPrevTabBtn').removeClass('hidden');
             }
             if (activeTabId === "tab3staff") {
             $("#stf-proceed").text("Save");
             }
             if (activeTabId === "tab4staff") {*/
            var formData = this.staffData;
            staffCreateLoader.start();
            this.$http.post("/staff/add", formData).then(
                (response) => {
                    if (response.data.hasError) {
                        this.errorMessage = "Something went wrong";
                        toastr["error"](response.body.message);
                        staffCreateLoader.stop();
                        staffCreateLoader.remove();
                        return false;
                    }
                    //this.staffData = {};
                    this.staffData = {
                        name: "",
                        email: "",
                        mobile: "",
                        language: [],
                        documentAbsolutePath: [],
                        designation: [],
                        specialisation: [],
                    };
                    this.resetAddressForm();
                    this.resetForm();
                    this.errorMessage = "";
                    $("#addStaff").modal("hide");
                    toastr["success"](response.body.message);
                    if (response.data.result.code !== undefined) {
                        window.location.href =
                            "/staff/" + response.data.result.code;
                    } else if (typeof appStaff !== "undefined") {
                        appStaff.getVueItems(1);
                    } else {
                        window.location.href = "/staff";
                    }
                },
                (response) => {
                    this.errorMessage = "Something went wrong!";
                    toastr["error"]("Something went wrong!", "Failed");
                    staffCreateLoader.stop();
                    staffCreateLoader.remove();
                }
            );
            /*} else {
             $('.nav-pills > .active').next('li').find('a').trigger('click');
             }
             //            }*/
        },
        updateStaffBasicInfo: function(staffId) {
            var staffUpdateLoader = Ladda.create(
                document.querySelector(".staffBtnUpdateLoader")
            );

            this.errorMessage = "";
            var isValid = validate.formIsValid("staffForm");
            var customValidateElements = $("#addStaff div.multiselect").map(
                function(i, element) {
                    if (
                        $(element).data("optional") === undefined ||
                        $(element).data("optional") == false
                    ) {
                        return $(element)
                            .find("input")
                            .attr("id");
                    }
                }
            );
            var otherCustomValidElements = $("#addStaff div.multiselect").map(
                function(i, element) {
                    var elemId = $(element)
                        .attr("id")
                        .replace("-multiselect", "");
                    if (
                        $(element).data("optional") === undefined ||
                        $(element).data("optional") == false
                    ) {
                        if (customValidateElements.length > 0) {
                            if (
                                $.inArray(elemId, customValidateElements) == -1
                            ) {
                                return elemId;
                            }
                        } else {
                            return elemId;
                        }
                    }
                }
            );
            var customValidate = validate.customValidateMultiSelect(
                customValidateElements
            );
            var customValidate =
                validate.customValidateMultiSelect(customValidateElements) &&
                validate.customValidateMultiSelect(otherCustomValidElements);

            if (!(isValid && customValidate && this.verificationError == "")) {
                return false;
            }

            var formData = this.staffData;
            formData.removedDocumentList = staffManage.removedDocumentList;
            staffUpdateLoader.start();
            this.$http
                .post(
                    "/staff/update/basicinfo/" + this.staffData.staffCode,
                    formData
                )
                .then(
                    (response) => {
                        if (response.data.hasError) {
                            this.errorMessage = "Something went wrong";
                            toastr["error"](response.body.message);
                            staffUpdateLoader.stop();
                            staffUpdateLoader.remove();
                            return false;
                        }
                        //this.staffData = {};
                        this.staffData = {
                            name: "",
                            email: "",
                            mobile: "",
                            language: [],
                            documentAbsolutePath: [],
                            designation: [],
                            specialisation: [],
                            document: [],
                        };
                        this.resetAddressForm();
                        this.resetForm();
                        this.errorMessage = "";
                        staffUpdateLoader.stop();
                        staffUpdateLoader.remove();
                        $("#addStaff").modal("hide");
                        toastr["success"](response.body.message);
                        if (typeof appStaff !== "undefined") {
                            appStaff.getVueItems(1);
                        }
                        if ($("#clkstaffDetails").length) {
                            $("#clkstaffDetails").trigger("click");
                        }
                    },
                    (response) => {
                        this.errorMessage = "Something went wrong!";
                        toastr["error"]("Something went wrong!", "Failed");
                        staffUpdateLoader.stop();
                        staffUpdateLoader.remove();
                    }
                );
        },
        onChangeAddressMode: function() {
            var isChecked = $("#staffadd").is(":checked");

            if (isChecked) {
                this.staffData.permanentStreetAddress = this.staffData.presentStreetAddress;
                this.staffData.permanentPincode = this.staffData.presentPincode;
                this.staffData.permanentLocalityId = this.staffData.presentLocalityId;
                this.selectedPermanentState = this.selectedPresentState;
                this.selectedPermanentCity = this.selectedPresentCity;
                this.selectedPermanentLocality = this.selectedPresentLocality;
                this.permanentLocalityList = this.presentLocalityList;
                $("div.spermanentAddress")
                    .find("#permanentStreetAddress")
                    .prop("readonly", true);
                $("div.spermanentAddress")
                    .find("#permanentPincode")
                    .prop("readonly", true);
                if (
                    this.selectedPermanentLocality ==
                    this.selectedPresentLocality
                ) {
                    staffManage.isLocalityDisabled = true;
                    setTimeout(function() {
                        validate.customValidateMultiSelect([
                            "stfPermanentLocality",
                        ]);
                    }, 100);
                }
            } else if (this.staffData.id == null || this.staffData.id != null) {
                this.staffData.permanentStreetAddress = "";
                this.staffData.permanentPincode = "";
                $("div.spermanentAddress")
                    .find("#permanentStreetAddress")
                    .prop("readonly", false);
                $("div.spermanentAddress")
                    .find("#permanentPincode")
                    .prop("readonly", false);
                staffManage.isLocalityDisabled = false;
                this.staffData.permanentLocalityId = "";
                staffManage.selectedPermanentLocality = [];
                staffManage.selectedPermanentState = [];
                staffManage.selectedPermanentCity = [];
                staffManage.localityList = [];
                staffManage.permanentLocalityList = [];
            }
        },
        addStaffPrevTab: function() {
            $(".nav-pills > .active")
                .prev("li")
                .find("a")
                .trigger("click");
            var previousTabId = $("div#addStaff")
                .find(".tab-content > .active")
                .prev(".tab-pane")
                .attr("id");
            if (previousTabId === "tab1staff") {
                $("#addStaffPrevTabBtn").addClass("hidden");
            }
        },
        validateStaffUser: function() {
            var update = "";
            if (
                $.trim(this.staffData.mobile + "" + this.staffData.email) == ""
            ) {
                this.verificationError = "";
                return false;
            }
            if (this.formHeader == "Update Staff") {
                return false;
            }
            this.$http
                .get(
                    "/user/details/bymobileemail?mobile=" +
                        this.staffData.mobile +
                        "&email=" +
                        this.staffData.email
                )
                .then((response) => {
                    if (response.body.hasError) {
                        this.verificationError = response.body.message;
                        return false;
                    }
                    var result = response.body.result;
                    this.verificationError = "";
                    if (result.user.staff.isStaff === true) {
                        $("#stf-proceed").prop("disabled", true);
                        toastr["error"]("Staff Already Exists!");
                    } else if (result.user) {
                        $("#stf-proceed").prop("disabled", false);
                        if (result.user.email) {
                            this.staffData.email = result.user.email;
                        }
                        if (result.user.mobile) {
                            this.staffData.mobile = result.user.mobile;
                        }
                        if (result.user.firstName) {
                            this.staffData.name = result.user.firstName;
                        }
                        if (result.user.gender !== null) {
                            var genderTypeArr = $.map(this.genderList, function(
                                value,
                                index
                            ) {
                                if (
                                    value.name.toLowerCase() ==
                                    result.user.gender.toLowerCase()
                                ) {
                                    return value;
                                }
                            });
                            this.selectedGender =
                                genderTypeArr.length == 0
                                    ? []
                                    : genderTypeArr[0];
                            this.staffData.gender =
                                staffManage.selectedGender.id;
                        }
                        if (result.user.roles.length) {
                            this.selectedDesignation = result.user.roles;
                        }
                    }
                });
        },
    },
});

Vue.mixin({
    methods: {
        disableStaff: function() {
            var disableStaffLoader = Ladda.create(
                document.querySelector(".disableStaffBtnLoader")
            );
            var staffCode = $("#removeStaffItemConfirmModal").data("staffCode");
            var disable = $("#removeStaffItemConfirmModal").data("disable");
            var url = disable
                ? "/staff/disable/" + staffCode
                : "/staff/enable/" + staffCode;
            disableStaffLoader.start();
            if (
                disable &&
                (this.hasLeadsAssigned ||
                    this.hasPackagesAssigned ||
                    this.hasMemberFollowup)
            ) {
                var postData = {};
                postData["hasLeadsAssigned"] = this.hasLeadsAssigned;
                postData["hasMemberFollowup"] = this.hasMemberFollowup;
                postData["hasPackagesAssigned"] = this.hasPackagesAssigned;
                postData["fromStaffCode"] = this.fromStaffCode;
                postData["assignToStaffCode"] = this.assignToStaffCode;
                postData["assignToTrainerCode"] = this.assignTrainerTo;
                postData[
                    "memberFollowupAssignToStaffCode"
                ] = this.assignMemberFollowupTo;
                console.log(
                    this.hasPackagesAssigned,
                    this.assignTrainerTo,
                    this.hasLeadsAssigned,
                    this.assignToStaffCode
                );
                if (
                    (this.hasLeadsAssigned && !this.assignToStaffCode) ||
                    (this.hasPackagesAssigned && !this.assignTrainerTo) ||
                    (this.hasMemberFollowup && !this.assignMemberFollowupTo)
                ) {
                    //error
                    toastr["error"]("Required fields can't be empty");
                    disableStaffLoader.stop();
                    disableStaffLoader.remove();
                } else {
                    // API call
                    this.$http.post("/staff/assignment/update", postData).then(
                        (response) => {
                            if (!response.body.hasError) {
                                this.$http.post(url).then(
                                    (response) => {
                                        if (response.data.hasError) {
                                            toastr["error"](
                                                response.body.message
                                            );
                                            disableStaffLoader.stop();
                                            disableStaffLoader.remove();
                                            return false;
                                        }
                                        toastr["success"](
                                            response.body.message
                                        );
                                        disableStaffLoader.stop();
                                        this.assignTrainerTo = "";
                                        this.assignToStaffCode = "";
                                        this.assignMemberFollowupTo = "";
                                        disableStaffLoader.remove();
                                        $("#removeStaffItemConfirmModal").modal(
                                            "hide"
                                        );
                                        if (typeof appStaff !== "undefined") {
                                            appStaff.getVueItems(1);
                                        }
                                        if ($("#clkstaffDetails").length) {
                                            $("#clkstaffDetails").trigger(
                                                "click"
                                            );
                                        }
                                    },
                                    (response) => {
                                        toastr["error"](
                                            "Something went wrong!",
                                            "Failed"
                                        );
                                        disableStaffLoader.stop();
                                        disableStaffLoader.remove();
                                    }
                                );
                            } else {
                                toastr["error"]("Select a value");
                                disableStaffLoader.stop();
                                disableStaffLoader.remove();
                            }
                        },
                        (response) => {
                            toastr["error"](
                                "Update Assignment Failed, try again!"
                            );
                            disableStaffLoader.stop();
                            disableStaffLoader.remove();
                        }
                    );
                }
            } else {
                this.$http.post(url).then(
                    (response) => {
                        if (response.data.hasError) {
                            toastr["error"](response.body.message);
                            disableStaffLoader.stop();
                            disableStaffLoader.remove();
                            return false;
                        }

                        toastr["success"](response.body.message);
                        disableStaffLoader.stop();
                        disableStaffLoader.remove();
                        $("#removeStaffItemConfirmModal").modal("hide");
                        if (typeof appStaff !== "undefined") {
                            appStaff.getVueItems(1);
                        }
                        if ($("#clkstaffDetails").length) {
                            $("#clkstaffDetails").trigger("click");
                        }
                    },
                    (response) => {
                        toastr["error"]("Something went wrong!", "Failed");
                        disableStaffLoader.stop();
                        disableStaffLoader.remove();
                    }
                );
            }
        },
        deleteStaff: function() {
            var staffCode = $("#deleteStaffItemConfirmModal").data("staffCode");
            if (
                this.hasLeadsAssigned ||
                this.hasPackagesAssigned ||
                this.hasMemberFollowup
            )
                this.updateAssignmentofLeadsPackages();
            else this.deleteStaffCompletely(staffCode);
        },
        disableStaffShow: function(staffCode, disable) {
            $("#removeStaffItemConfirmModal .ConfMsg").addClass("hidden");
            if (disable) {
                this.selectedAssignLead = "";
                this.selectedAssignTrainer = "";
                this.selectedAssignFollowup = "";
                this.assignToStaffCode = "";
                this.assignTrainerTo = "";
                this.assignMemberFollowupTo = "";
                this.fromStaffCode = staffCode;
                this.$http
                    .get("/staff/check/assignment/" + staffCode)
                    .then((response) => {
                        if (response.body.hasError) {
                            toastr["error"](response.body.message);
                        } else {
                            this.hasLeadsAssigned =
                                response.body.result.hasLeadsAssigned;
                            this.hasPackagesAssigned =
                                response.body.result.hasPackagesAssigned;
                            this.hasMemberFollowup =
                                response.body.result.hasMemberFollowup;
                            if (this.hasLeadsAssigned) {
                                this.getAllStaffList();
                            }
                            if (this.hasPackagesAssigned) {
                                this.getAllTrainerList();
                            }
                            if (this.hasMemberFollowup) {
                                this.getStaffByPermission();
                            }
                        }
                    });
                $("#removeStaffItemConfirmModal")
                    .find("#disableStaff")
                    .removeClass("hidden");
            } else {
                $("#removeStaffItemConfirmModal")
                    .find("#enableStaff")
                    .removeClass("hidden");
            }
            $("#removeStaffItemConfirmModal")
                .data("staffCode", staffCode)
                .data("disable", disable)
                .modal("show");
        },
        deleteStaffShow: function(staffCode) {
            this.fromStaffCode = staffCode;
            this.$http
                .get("/staff/check/assignment/" + staffCode)
                .then((response) => {
                    if (response.body.hasError) {
                        toastr["error"](response.body.message);
                    } else {
                        this.hasLeadsAssigned =
                            response.body.result.hasLeadsAssigned;
                        this.hasPackagesAssigned =
                            response.body.result.hasPackagesAssigned;
                        this.hasMemberFollowup =
                            response.body.result.hasMemberFollowup;
                        if (this.hasLeadsAssigned) {
                            this.getAllStaffList();
                        }
                        if (this.hasPackagesAssigned) {
                            this.getAllTrainerList();
                        }
                        if (this.hasMemberFollowup) {
                            this.getStaffByPermission();
                        }
                    }
                });
            $("#deleteStaffItemConfirmModal")
                .data("staffCode", staffCode)
                .modal("show");
        },
        getAllTrainerList: function() {
            this.$http.get("/trainer/list").then((response) => {
                this.trainerList = response.data.result.filter(
                    (res) => res.code !== this.fromStaffCode
                );
            });
        },
        getAllStaffList: function() {
            this.$http.get("/lead/assignto/list").then((response) => {
                this.leadAssignToList = response.data.result.filter(
                    (res) => res.code !== this.fromStaffCode
                );
            });
        },
        getStaffByPermission: function() {
            this.$http.get("/staff/list/bypermission").then((response) => {
                this.followupAssignToList = response.data.result.filter(
                    (res) => res.code !== this.fromStaffCode
                );
            });
        },
        selectLeadAssignToList: function(value, id) {
            this.assignToStaffCode = value.code;
        },
        selectTrainer: function(value, id) {
            this.assignTrainerTo = value.code;
        },
        selectFollowupAssignTo: function(value, id) {
            this.assignMemberFollowupTo = value.code;
        },
        updateAssignmentofLeadsPackages: function() {
            var postData = {};
            postData["hasLeadsAssigned"] = this.hasLeadsAssigned;
            postData["hasPackagesAssigned"] = this.hasPackagesAssigned;
            postData["hasMemberFollowup"] = this.hasMemberFollowup;
            postData["fromStaffCode"] = this.fromStaffCode;
            postData["assignToStaffCode"] = this.assignToStaffCode;
            postData["assignToTrainerCode"] = this.assignTrainerTo;
            postData[
                "memberFollowupAssignToStaffCode"
            ] = this.assignMemberFollowupTo;

            var Loader = Ladda.create(
                document.querySelector(".deleteStaffBtnLoader")
            );
            Loader.start();
            this.$http.post("/staff/assignment/update", postData).then(
                (response) => {
                    Loader.stop();
                    Loader.remove();
                    if (!response.body.hasError) {
                        this.deleteStaffCompletely(this.fromStaffCode);
                    }
                },
                (response) => {
                    toastr["error"]("Update Assignment Failed, try again!");
                    Loader.stop();
                    Loader.remove();
                }
            );
        },
        deleteStaffCompletely: function(staffCode) {
            var deleteStaffLoader = Ladda.create(
                document.querySelector(".deleteStaffBtnLoader")
            );
            deleteStaffLoader.start();
            var url = "/staff/delete/" + staffCode;
            this.$http.post(url).then(
                (response) => {
                    if (response.data.hasError) {
                        toastr["error"](response.body.message);
                        deleteStaffLoader.stop();
                        deleteStaffLoader.remove();
                        return false;
                    }
                    toastr["success"](response.body.message);
                    $("#deleteStaffItemConfirmModal").modal("hide");
                    if (typeof appStaff !== "undefined") {
                        appStaff.getVueItems(1);
                    }
                    if ($("#clkstaffDetails").length) {
                        $("#clkstaffDetails").trigger("click");
                    }
                    deleteStaffLoader.stop();
                    deleteStaffLoader.remove();
                },
                (response) => {
                    toastr["error"]("Something went wrong!", "Failed");
                    deleteStaffLoader.stop();
                    deleteStaffLoader.remove();
                }
            );
        },
        editStaff: function(staff, baseUrl) {
            $("form label.error").hide();
            var isEdit = $("#isEdit").val(staff.staffCode);
            var dateOfBirth = null;
            if (staff.staffDob) {
                dateOfBirth = moment(staff.staffDob, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                );
            }
            staffManage.formHeader = "Update Staff";
            staffManage.createNew = false;
            staffManage.staffData = staff;
            staffManage.staffData.id = staff.staffCode;
            staffManage.staffData.staffCode = staff.staffCode;
            staffManage.staffData.name = staff.staffName;
            staffManage.staffData.email = staff.staffEmail;
            staffManage.staffData.dob = dateOfBirth;
            staffManage.readOnlyEmail = staffManage.staffData.email
                ? true
                : false;
            staffManage.staffData.mobile = staff.staffMobile;
            staffManage.readOnlyMobile = staffManage.staffData.mobile
                ? true
                : false;
            //select Gender
            staffManage.selectedGender = $.map(staffManage.genderList, function(
                value,
                index
            ) {
                if (value.name == staff.staffGender) {
                    return value;
                }
            });
            staffManage.selectedGender =
                staffManage.selectedGender.length == 0
                    ? []
                    : staffManage.selectedGender[0];
            staffManage.staffData.gender = staffManage.selectedGender.id;
            //staffManage.staffData.age = staff.user.age;
            // if (staff.user.language == null) {
            //     '';
            // } else if (staff.user.language.length !== 0) {
            //     staffManage.staffData.language = staff.user.language.split(",");
            // }
            // if (staff.user.document == null) {
            // } else if (staff.user.document.length !== 0) {
            //     var documnetArray = staff.user.document.split(",");
            //     var docUrlArray = documnetArray.map((item) => {
            //         return baseUrl + item;
            //     });
            //     staffManage.staffDocumentList = docUrlArray;
            // }

            if (staff.reportToUserCode !== null) {
                staffManage.staffData.reportingManager = staff.reportToUserCode;
            }
            staffManage.staffData.specialisation = [];
            if (typeof staff.staff_specializations !== "undefined") {
                var avaliableSpecialisation = $.map(
                    staff.staff_specializations,
                    function(value, index) {
                        //                    alert(JSON.stringify(value.id));
                        return value.code;
                    }
                );
                staffManage.staffData.specialisation = avaliableSpecialisation;
            }
            if (typeof typeof staff.roles !== "undefined") {
                var avaliableDesignation = $.map(staff.roles, function(
                    value,
                    index
                ) {
                    return value.name;
                });
                staffManage.staffData.designation = avaliableDesignation;
            }
            //            staffManage.staffData.specialisation = (typeof staff.user.staff_specialization[0] === 'undefined') ? '' : staff.user.staff_specialization[0].id;
            //            staffManage.staffData.specialisation = staff.user.staff_specialization.map((item) => {
            //                return item.id;
            //            });
            //            staffManage.staffData.designation = (typeof staff.user.roles[0] === 'undefined') ? '' : staff.user.roles[0].id;
            //            staffManage.staffData.designation = staff.user.roles.map((item) => {
            //                return item.id;
            //            });
            if (
                staff &&
                staff.user &&
                staff.user.user_address &&
                staff.user.user_address[0] &&
                staff.user.user_address[0].locality
            ) {
                staffManage.staffData.presentStreetAddress =
                    typeof staff.user.user_address[0] === "undefined"
                        ? ""
                        : staff.user.user_address[0].address;
                staffManage.staffData.presentPincode =
                    typeof staff.user.user_address[0].locality === "undefined"
                        ? ""
                        : staff.user.user_address[0].locality.pincode;
                staffManage.staffData.presentLocalityId =
                    typeof staff.user.user_address[0].locality === "undefined"
                        ? ""
                        : staff.user.user_address[0].locality.id;
                staffManage.staffData.presentCityId =
                    typeof staff.user.user_address[0].locality.city ===
                    "undefined"
                        ? ""
                        : staff.user.user_address[0].locality.cityId;
                staffManage.staffData.presentStateId =
                    typeof staff.user.user_address[0].locality.city.state ===
                    "undefined"
                        ? ""
                        : staff.user.user_address[0].locality.city.stateId;
                staffManage.getRelatedLocalityCityState(
                    staff.user.user_address[0].locality.pincode,
                    "present"
                );
                staffManage.staffData.permanentStreetAddress =
                    typeof staff.user.user_address[1] === "undefined"
                        ? ""
                        : staff.user.user_address[1].address;
                staffManage.staffData.permanentPincode =
                    typeof staff.user.user_address[1].locality === "undefined"
                        ? ""
                        : staff.user.user_address[1].locality.pincode;
                staffManage.staffData.permanentLocalityId =
                    typeof staff.user.user_address[1].locality === "undefined"
                        ? ""
                        : staff.user.user_address[1].locality.id;
                staffManage.staffData.permanentCityId =
                    typeof staff.user.user_address[1].locality.city ===
                    "undefined"
                        ? ""
                        : staff.user.user_address[1].locality.cityId;
                staffManage.staffData.permanentStateId =
                    typeof staff.user.user_address[1].locality.city.state ===
                    "undefined"
                        ? ""
                        : staff.user.user_address[1].locality.city.stateId;
                staffManage.getRelatedLocalityCityState(
                    staff.user.user_address[1].locality.pincode,
                    "permanent"
                );

                if (
                    staff.user.user_address[0].address ==
                        staff.user.user_address[1].address &&
                    staff.user.user_address[0].locality.pincode ==
                        staff.user.user_address[1].locality.pincode &&
                    staff.user.user_address[0].locality.city.stateId ==
                        staff.user.user_address[1].locality.city.stateId &&
                    staff.user.user_address[0].locality.cityId ==
                        staff.user.user_address[1].locality.cityId
                ) {
                    $("#staffadd").prop("checked", true);
                    $("div.spermanentAddress")
                        .find("#permanentStreetAddress")
                        .prop("readonly", true);
                    $("div.spermanentAddress")
                        .find("#permanentPincode")
                        .prop("readonly", true);
                    staffManage.isLocalityDisabled = true;
                } else {
                    $("#staffadd").prop("checked", false);
                    $("div.spermanentAddress")
                        .find("#permanentStreetAddress")
                        .prop("readonly", false);
                    $("div.spermanentAddress")
                        .find("#permanentPincode")
                        .prop("readonly", false);
                    staffManage.isLocalityDisabled = false;
                }
            }
            staffManage.openStaffForm();
            //            setTimeout(function () {
            //                $(".select-two").trigger('change');
            //            }, 1);
        },
    },
});
